import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setStateScrolling } from "../actions/index";

const usePageScroll = () => {
  const dispatch = useDispatch();
  const onScroll = (e) => { dispatch(setStateScrolling(true)); }
  useEffect(() => {
    dispatch(setStateScrolling(false));
    return () => { setStateScrolling(false); }
  }, [dispatch])
  return { onScroll };
};

export default usePageScroll;
